<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <img
        src="/img/hamkaran_cloudpbx.png"
        alt="تلفن ابری همکاران"
        class="c-sidebar-brand-full sidebrand"
      />

      <img
        src="/img/hamkaran_cloudpbx_mini.png"
        alt="تلفن ابری همکاران"
        class="c-sidebar-brand-minimized mini-sidebrand"
      />
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="$options.nav" />

    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from "./_nav";

export default {
  methods: {
    create () { 
 
    if (this.$store.state.data.ticketsCount) {
      this.badge = {
        color: "danger",
        text: this.$store.state.data.ticketsCount,
      };
    } else {
      this.badge = {};
    }
    this.$options.nav[0]._children = [];
    if (this.$store.state.data.access_level === 1) {
      this.$options.nav[0]._children.push(
        {
          _name: "CSidebarNavDropdown",
          name: "مدیریت خدمات",
          route: "/admin",
          show: true,
          icon: {
            src: "/img/admin.png",
            class: "hamkaran-sidebar-nav-icon",
          },
          items: [
            {
              name: "مدیریت مراکز تماس",
              to: "/admin/pbxs",
            },
            {
              name: "تیکت‌های پشتیبانی",
              to: "/admin/tickets",
              badge: this.badge,
            },
            {
              name: "پایش داخلی‌ها",
              to: "/get_settings",
            },
            {
              name: "خطوط مخابراتی",
              to: "/admin/bi/pstn",
            },
            {
              name: "اتصالات",
              to: "/admin/integrations",
            },
            {
              name: "دیوار آتش",
              to: "/admin/firewall",
            },
            {
              name: "مانیتورینگ زیرساخت",
              to: "/admin/bi/elk",
            },
          ],
        },
        {
          _name: "CSidebarNavDropdown",
          name: "مالی و حسابداری",
          to: "/reports",
          icon: {
            src: "/img/accounting.png",
            class: "hamkaran-sidebar-nav-icon",
          },
          items: [
            {
              name: "انواع محصولات",
              to: "/admin/products",
              badge: {
                color: "primary",
                text: "جدید",
                shape: "pill",
              },
            },
            {
              name: "فاکتور های صادر شده",
              to: "/admin/trunks-advance",
              badge: {
                color: "warning",
                text: "به زودی",
                shape: "pill",
              },
            },
            {
              name: "لاگ پرداخت",
              to: "/admin/payments",
              badge: {
                color: "primary",
                text: "جدید",
                shape: "pill",
              },
            },
          ],
        },
        {
          _name: "CSidebarNavDropdown",
          name: "فروش و مارکتینگ",
          to: "/reports",
          icon: {
            src: "/img/sales.png",
            class: "hamkaran-sidebar-nav-icon",
          },
          items: [
            {
              name: "لیست نهال‌ها",
              to: "/admin/seedlings",
            },
            {
              name: "گزارش ثبت‌ نام‌ها",
              to: "/admin/reports/registrations",
            },
            {
              name: "گزارش تماس ها",
              to: "/reports",
            },
            {
              name: "مشارکت در فروش ها",
              to: "/admin/trunks-advance",
              badge: {
                color: "warning",
                text: "به زودی",
                shape: "pill",
              },
            },
            {
              name: "Marketing Summary",
              to: "/admin/bi/marketing_summary",
            },
            {
              name: "Google Analytics",
              to: "/admin/bi/google_analytics",
            },
            {
              name: "Search Console",
              to: "/admin/bi/search_console",
            },
            {
              name: "Google ADS",
              to: "/admin/bi/google_ads",
            },
          ],
        },
        {
          _name: "CSidebarNavDropdown",
          name: "نگهداری و تعمیرات",
          to: "/maintenance",
          icon: {
            src: "/img/maintenance.png",
            class: "hamkaran-sidebar-nav-icon",
          },
          items: [
            {
              name: "مدیریت اموال و دارایی‌ها",
              to: "/admin/property",
            },
          ],
        },
        {
          _name: "CSidebarNavDropdown",
          name: "تنظیمات",
          to: "/admin/setting",
          icon: {
            src: "/img/admin_settings.png",
            class: "hamkaran-sidebar-nav-icon",
          },
          items: [
            {
              name: "قالب‌های واتساپ",
              to: "/admin/template/whatsapp_list",
              badge: {
                color: "primary",
                text: "جدید",
                shape: "pill",
              },
            },
            {
              name: "کد تخفیف",
              to: "/admin/discounts",
            },
            {
              name: "قالب‌های ایمیل",
              to: "/admin/template/emails",
            },
            {
              name: "مدیریت پرسنل",
              to: "/admin/users",
            },
          ],
        }
      );
    }else if (this.$store.state.data.access_level === 14) {
      this.$options.nav[0]._children.push(
        {
          _name: "CSidebarNavDropdown",
          name: "راهبری مرکز تماس ابری",
          route: "/admin",
          show: true,
          icon: {
            src: "/img/admin.png",
            class: "hamkaran-sidebar-nav-icon",
          },
          items: [
            {
              name: "مدیریت مراکز تماس",
              to: "/admin/pbxs",
            },
            {
              name: "تیکت‌های پشتیبانی",
              to: "/admin/tickets",
              badge: this.badge,
            },
            {
              name: "پایش داخلی‌ها",
              to: "/get_settings",
            }
          ],
        },
        {
          _name: "CSidebarNavDropdown",
          name: "مانیتورینگ",
          to: "/reports",
          icon: {
            src: "/img/server_monitoring.png",
            class: "hamkaran-sidebar-nav-icon",
          },
          items: [
            {
              name: "Marketing Summary",
              to: "/admin/bi/marketing_summary",
            },
            {
              name: "Google Analytics",
              to: "/admin/bi/google_analytics",
            },
            {
              name: "Search Console",
              to: "/admin/bi/search_console",
            },
            {
              name: "Google ADS",
              to: "/admin/bi/google_ads",
            },
          ],
        },
        {
          _name: "CSidebarNavDropdown",
          name: "مالی و حسابداری",
          to: "/reports",
          icon: {
            src: "/img/accounting.png",
            class: "hamkaran-sidebar-nav-icon",
          },
          items: [
            {
              name: "انواع محصولات",
              to: "/admin/products",
              badge: {
                color: "primary",
                text: "جدید",
                shape: "pill",
              },
            },
            {
              name: "لاگ پرداخت",
              to: "/admin/payments",
              badge: {
                color: "primary",
                text: "جدید",
                shape: "pill",
              },
            },
          ],
        },
        {
          _name: "CSidebarNavDropdown",
          name: "فروش و مارکتینگ",
          to: "/reports",
          icon: {
            src: "/img/sales.png",
            class: "hamkaran-sidebar-nav-icon",
          },
          items: [
            {
              name: "لیست نهال‌ها",
              to: "/admin/seedlings",
              badge: {
                color: "primary",
                text: "جدید",
                shape: "pill",
              },
            },
            {
              name: "کد تخفیف",
              to: "/admin/discounts",
            },
            {
              name: "گزارش ثبت‌ نام‌ها",
              to: "/admin/reports/registrations",
            },
            {
              name: "مشارکت در فروش ها",
              to: "/",
              badge: {
                color: "warning",
                text: "به زودی",
                shape: "pill",
              },
            },
          ],
        }
      );
    }else if (this.$store.state.data.access_level === 15) {
      this.$options.nav[0]._children.push(
        {
          _name: "CSidebarNavItem",
          name: "لیست نهال‌ها",
          to: "/admin/seedlings",
          icon: {
            src: "/img/seedling_icon.png",
            class: "hamkaran-sidebar-nav-icon",
          },
        },
        {
          _name: "CSidebarNavItem",
          name: "گزارش ثبت‌ نام‌ها",
          to: "/admin/reports/registrations",
          icon: {
            src: "/img/registration.png",
            class: "hamkaran-sidebar-nav-icon",
          },
        },
        {
          _name: "CSidebarNavItem",
          name: "گزارش تماس ها",
          to: "/reports",
          icon: {
            src: "/img/call_log.png",
            class: "hamkaran-sidebar-nav-icon",
          },
        },
        {
          _name: "CSidebarNavItem",
          name: "دفترچه تلفن",
          to: "/contacts",
          icon: {
            src: "/img/phone-book.png",
            class: "hamkaran-sidebar-nav-icon",
          },
        },
        {
          _name: "CSidebarNavItem",
          name: "صندوق صوتی",
          to: "/voicemails",
          icon: {
            src: "/img/voicemail.png",
            class: "hamkaran-sidebar-nav-icon",
          },
        }
      );
      this.$options.nav[0]._children.push({
        _name: "CSidebarNavItem",
        name: "فکس",
        to: "/fax",
        icon: {
          src: "/img/fax.png",
          class: "hamkaran-sidebar-nav-icon",
        },
        badge: {
          color: "warning",
          text: "آزمایشی",
          shape: "pill",
        },
      });
    } else {
      this.$options.nav[0]._children.push(
        {
          _name: "CSidebarNavItem",
          name: "دریافت تنظیمات",
          to: "/get_settings",
          icon: {
            src: "/img/config.png",
            class: "hamkaran-sidebar-nav-icon",
          },
        },
        {
          _name: "CSidebarNavItem",
          name: "گزارش تماس ها",
          to: "/reports",
          icon: {
            src: "/img/call_log.png",
            class: "hamkaran-sidebar-nav-icon",
          },
        },
        {
          _name: "CSidebarNavItem",
          name: "صندوق صوتی",
          to: "/voicemails",
          icon: {
            src: "/img/voicemail.png",
            class: "hamkaran-sidebar-nav-icon",
          },
        },
        {
          _name: "CSidebarNavItem",
          name: "دفترچه تلفن",
          to: "/contacts",
          icon: {
            src: "/img/phone-book.png",
            class: "hamkaran-sidebar-nav-icon",
          },
        }
      );
      this.$options.nav[0]._children.push({
        _name: "CSidebarNavItem",
        name: "فکس",
        to: "/fax",
        icon: {
          src: "/img/fax.png",
          class: "hamkaran-sidebar-nav-icon",
        },
        badge: {
          color: "warning",
          text: "آزمایشی",
          shape: "pill",
        },
      });
      this.$options.nav[0]._children.push({
        _name: "CSidebarNavItem",
        name: "اتصالات",
        to: "/integrations",
        icon: {
          src: "/img/api.png",
          class: "hamkaran-sidebar-nav-icon",
        }
      });
      this.$options.nav[0]._children.push({
        _name: "CSidebarNavItem",
        name: "پشتیبانی",
        class: "not_active",
        to: "/ticket",
        icon: {
          src: "/img/technical-support.png",
          class: "hamkaran-sidebar-nav-icon",
        },
      },{
        _name: "CSidebarNavItem",
        name: "دیوار آتش",
        class: "not_active",
        to: "/bancheck",
        icon: {
          src: "/img/firewall.png",
          class: "hamkaran-sidebar-nav-icon",
        },
        badge: {
          color: "light",
          text: "جدید",
          shape: "pill",
        },
      });
    }
    },
  },
  watch: {
    
    '$store.state.data.ticketsCount': function() {
      this.create();
    },
    
  },
  data() {
    return {
      badge: {},
    };
  },
  created() {
    this.create();
  },
  name: "TheSidebar",
  nav,
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
};
</script>
